import { render, staticRenderFns } from "./FaqSection.vue?vue&type=template&id=53de7f39&scoped=true"
import script from "./FaqSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de7f39",
  null
  
)

export default component.exports